import React, { useState } from 'react';

import isEqual from 'lodash/isEqual';

import {
  ToggleButtonGroup,
  RadioGroupOption,
  RadioGroup,
  ToggleButton,
  Grid,
  TextField,
} from '@gogame/components';
import { withFormField } from '@gogame/form';

const lifetime = { length: null, unit: 'Day' };
const regday = { length: 1, unit: 'Day' };
const custom = { length: 0, unit: 'Day' };

const LIFETIME = 'LIFETIME';
const REG_DAY = 'REG_DAY';
const CUSTOM = 'CUSTOM';

const presets = {
  [LIFETIME]: lifetime,
  [REG_DAY]: regday,
  [CUSTOM]: custom,
};

const Period = (props) => {
  const { value } = props;

  const [selected, setSelected] = useState(() => {
    if (!value || !value.length) {
      return LIFETIME;
    }

    if (isEqual(value, presets[REG_DAY])) {
      return REG_DAY;
    }

    return CUSTOM;
  });

  const handleChange = (e, period) => {
    setSelected(period);
    props.onChange(e, presets[period]);
  };

  const handleUnitChange = (e, unit) => {
    props.onChange(e, {
      ...value,
      unit,
    });
  };

  const handleLengthChange = (e, length) => {
    props.onChange(e, {
      ...value,
      length,
    });
  };

  return (
    <Grid item container xs={4} direction={'column'} spacing={2}>
      <Grid item>
        <RadioGroup
          title={props.summary}
          onChange={handleChange}
          value={selected}
          vertical={true}
          padding={'0'}
          data-test-name={'TriggerPeriod'}
        >
          <RadioGroupOption
            label={'Lifetime'}
            data-test-name={LIFETIME}
            value={LIFETIME}
          />
          <RadioGroupOption
            label={'Reg day'}
            data-test-name={REG_DAY}
            value={REG_DAY}
          />
          <RadioGroupOption
            label={'Custom period'}
            data-test-name={CUSTOM}
            value={CUSTOM}
          />
        </RadioGroup>
      </Grid>
      {selected === CUSTOM && (
        <Grid item container spacing={2}>
          <Grid item xs={3}>
            <TextField
              type={'number'}
              onChange={handleLengthChange}
              value={value?.length}
            />
          </Grid>
          <Grid item>
            <ToggleButtonGroup
              size={'small'}
              color={'primary'}
              value={value?.unit}
              enforceValue={true}
              onChange={handleUnitChange}
            >
              {props.options.map((option, index) => (
                <ToggleButton key={index} value={option.name}>
                  {option.name}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default withFormField({
  padding: 0,
  name: 'period',
})(Period);
